import React from 'react';
import {CircularProgressbar, buildStyles} from 'react-circular-progressbar';
import './CircleProgressBar.scss';
import './Styles.scss';
import {easeQuadInOut} from 'd3-ease';
import ProgressProvider from './ProgressProvider';

export default function CircularProgressBar(props) {
  const isUnder75Color = 'var(--theme-primary, #9631ff)';
  const is75OrOverColor = '#e43f26';
  const usage = calcUsage(props.usage);
  const unit = props.unit;
  const outOfTotal = props.outOfTotal;
  const description = `מתוך ${outOfTotal}${unit}`;
  const underHeader = props.underHeader;

  function calcUsage(usage) {
    if (Number(usage) < 0.5 && Number(usage) > 0) {
      return '1';
    } else {
      let res = 0;
      if (Number(usage) >= 99 && Number(usage) < 100) {
        return '99';
      }
      res = Math.round(Number(usage));
      return res.toString();
    }
  }

  function CircleContainer(props) {
    return (
      <div className='all-circle-container'>
        <div className='circle-container'>
          <div className='circle-children'>{props.children}</div>
        </div>
      </div>
    );
  }

  return (
    <CircleContainer label='ניצלת' description={description} underHeader={underHeader}>
      <div className='top-label'>ניצלת</div>
      <ProgressProvider valueStart={0} valueEnd={usage} easingFunction={easeQuadInOut} duration={1.4}>
        {(usage) => (
          <CircularProgressbar
            value={usage}
            text={`${Math.round(usage)}%`}
            styles={buildStyles({
              textColor: usage >= 75 ? is75OrOverColor : isUnder75Color,
              pathColor: usage >= 75 ? is75OrOverColor : isUnder75Color,
              trailColor: '#e0e5e8',
              // pathTransitionDuration: 0.95,
              pathTransition: 'none',
            })}
          />
        )}
      </ProgressProvider>
      <p className='bottom-label'>{description}</p>
    </CircleContainer>
  );
}
